import React from 'react';
import { Tooltip } from 'antd';
import { CloseCircleOutlined, FastForwardOutlined, WarningOutlined } from '@ant-design/icons';
import styled from 'styled-components';

interface OwnProps {
  status: string;
  message: string;
  timeout: boolean;
  className?: string;
}

const Wrapper = styled.div`
  font-size: 20px;
`;

const SmallIconSpan = styled.span`
  margin-right: 8px;
`;

const JobStatus = ({ status, message, className, timeout = false }: OwnProps) => {
  const jobSkipped = status === 'skipped';
  const jobFailed = status === 'failed';
  const color = jobFailed ? 'red' : 'grey';
  return (
    <Wrapper className={className} style={{ color }}>
      <Tooltip title={message}>
        <SmallIconSpan>
          {jobSkipped && <FastForwardOutlined />}
          {jobFailed && <CloseCircleOutlined />}
          {timeout && <WarningOutlined />}
        </SmallIconSpan>
        {jobSkipped && 'Skipped'}
        {jobFailed && 'Failed'}
        {timeout && 'Timeout'}
      </Tooltip>
    </Wrapper>
  );
};

export default React.memo(JobStatus);
